export default __webpack_public_path__ + "slices/main/assets/public/media/masthead/cf-thumb@2x.0cfe9677b6bd3e3e3a828e7c8f769560.png";